
import { onMounted, ref } from 'vue'
import { PImportReports, ImportReport, useImportReports } from '@invivodf/common/src/contexts/parameters'

export default {
  name: 'VImportReports',
  components: { PImportReports },
  setup() {
    const error = ref('')
    const loading = ref(true)
    const importReports = ref<ImportReport[]>([])

    onMounted(async () => {
      try {
        const { fetchAll } = useImportReports()
        importReports.value = await fetchAll()
      } catch (err) {
        error.value = err
      } finally {
        loading.value = false
      }
    })

    return { error, loading, importReports }
  },
}
